<template>
  <div>
    <div class="newRow">
      <div style="display: flex">
        <h4>Payment Schedule</h4>
      </div>
      <div style="padding-left: 10px">
        <div class="row">
          <div class="col-sm-3">
            <base-input label="Contract Campaign Period" class="range-picker">
              <el-date-picker
                :modelValue="[
                  PaymentScheduleSummary.campaignPeriodStart,
                  PaymentScheduleSummary.campaignPeriodEnd,
                ]"
                type="daterange"
                placeholder="Campaign Date Range"
                :disabled-date="(val) => disabledDate(val)"
                class="form-control"
                value-format="YYYY-MM-DD"
                format="DD/MM/YYYY"
                disabled
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <base-input
              label="Total Media Amount"
              disabled
              :modelValue="
                formatter_money(PaymentScheduleSummary.totalMediaAmount)
              "
            >
              <!-- <money-input
                :model="PaymentScheduleSummary.totalMediaAmount"
                v-model="PaymentScheduleSummary.totalMediaAmount"
                style="background-color: #f5f5f5; color: #685b51"
              /> -->
            </base-input>
          </div>
          <div class="col-sm-5">
            <base-input
              label="Total Outstanding Media Amount"
              disabled
              :modelValue="
                formatter_money(
                  PaymentScheduleSummary.totalOutstandingMediaAmount
                )
              "
            >
              <!-- <money-input
                :model="PaymentScheduleSummary.totalOutstandingMediaAmount"
                v-model="PaymentScheduleSummary.totalOutstandingMediaAmount"
                style="background-color: #f5f5f5; color: #685b51"
              /> -->
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <base-input
              label="Total Production Amount"
              disabled
              :modelValue="
                formatter_money(PaymentScheduleSummary.totalProductionAmount)
              "
            >
              <!-- <money-input
                :model="PaymentScheduleSummary.totalProductionAmount"
                v-model="PaymentScheduleSummary.totalProductionAmount"
                style="background-color: #f5f5f5; color: #685b51"
              /> -->
            </base-input>
          </div>
          <div class="col-sm-5">
            <base-input
              label="Total Outstanding Production Amount"
              disabled
              :modelValue="
                formatter_money(
                  PaymentScheduleSummary.totalOutstandingProductionAmount
                )
              "
            >
              <!-- <money-input
                :model="PaymentScheduleSummary.totalOutstandingProductionAmount"
                v-model="
                  PaymentScheduleSummary.totalOutstandingProductionAmount
                "
                style="background-color: #f5f5f5; color: #685b51"
              />-->
            </base-input>
          </div>
        </div>
        <div>
          <el-tabs
            v-model="activeName"
            class="demo-tabs"
            @tab-click="handleClick"
          >
            <component
              :is="ComponentType"
              v-for="action in ActionNames"
              :key="'action' + action"
              :label="
                ['Media', 'Production'].filter(
                  (t) => t.toLowerCase() === action
                )[0]
              "
              :name="action"
            >
              <div
                style="
                  padding-top: 10px;
                  padding-bottom: 5px;
                  border-bottom: solid 1px #e3e3e3;
                  min-height: 36px;
                "
              >
                <base-button
                  type="primary"
                  v-if="
                    useContract.getContractFunctionPermission('Edit').enable
                  "
                  :disabled="useContract.disabled || addPaymentDisabled(action)"
                  link
                  class="base-icon-button"
                  @click="
                    dialogType = 'new';
                    dialogVisible = true;
                    payment_id = uuidv4().toUpperCase();
                  "
                >
                  <span class="icon-button add" style="margin-right: 10px">
                    <el-icon color="#fff" style="vertical-align: middle">
                      <plus />
                    </el-icon>
                  </span>
                  Add Payment Schedule</base-button
                >
              </div>
              <el-table
                :data="
                  paymentScheduleData.filter((t) => t.ContractAction === action)
                "
                :header-cell-class-name="SetHeaderBackground"
              >
                <el-table-column width="100">
                  <template #default="prop">
                    <el-button
                      link
                      @click="
                        dialogType = 'edit';
                        dialogVisible = true;
                        payment_id = prop.row.UniqueId;
                      "
                      v-if="
                        prop.row.InvoicedCount !=
                          prop.row.PaymentDetail.length &&
                        !useContract.getContractFunctionPermission('Edit')
                          ?.disable
                      "
                      :disabled="useContract.disabled"
                    >
                      <el-icon><Edit /></el-icon>
                    </el-button>
                    <el-button
                      link
                      style="margin-left: 0px"
                      @click="
                        dialogType = 'view';
                        dialogVisible = true;
                        payment_id = prop.row.UniqueId;
                      "
                    >
                      <el-icon><Search /></el-icon
                    ></el-button>

                    <el-button
                      link
                      style="margin-left: 0px"
                      v-if="
                        !prop.row.HasInvoiced &&
                        !useContract.getContractFunctionPermission('Edit')
                          ?.disable
                      "
                      :disabled="useContract.disabled"
                      @click="deleteClick(prop.row.UniqueId)"
                    >
                      <el-icon><Delete /> </el-icon>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="PS No." prop="PSNo" width="110">
                </el-table-column>
                <el-table-column
                  label="Description"
                  prop="Description"
                  min-width="130"
                />
                <el-table-column
                  label="From"
                  prop="CampaignPeriodStart"
                  min-width="60"
                >
                  <template #default="prop">
                    {{ formatDate(prop.row.CampaignPeriodStart) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="To"
                  prop="CampaignPeriodEnd"
                  min-width="60"
                >
                  <template #default="prop">
                    {{ formatDate(prop.row.CampaignPeriodEnd) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="No. of Schedule"
                  prop="NoOfSchedule"
                  min-width="130"
                />
                <el-table-column
                  label="Schedule Media Amount"
                  prop="ScheduleMediaAmount"
                  min-width="150"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.ScheduleMediaAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Schedule Production Amount"
                  prop="ScheduleProductionAmount"
                  min-width="220"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.ScheduleProductionAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Total Schedule Amount"
                  prop="TotalScheduleAmount"
                  min-width="150"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.TotalScheduleAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Paid Amount"
                  prop="PaidAmount"
                  min-width="70"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.PaidAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="HasInvoiced"
                  label="Has Invoice"
                  min-width="70"
                >
                  <template #default="scope">
                    <div>
                      {{ scope.row.HasInvoiced ? 'Yes' : '' }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </component>
            <!-- <el-tab-pane label="Production" name="production">
              <el-table :data="paymentScheduleProduction">
                <el-table-column width="70">
                  <template #default="prop">
                    <el-icon
                      style="position: relative; top: 3px; cursor: pointer"
                      @click="
                        dialogType = 'edit';
                        dialogVisible = true;
                      "
                      ><Edit
                    /></el-icon>
                    <el-icon
                      style="position: relative; top: 3px; cursor: pointer"
                      @click="
                        dialogType = 'view';
                        dialogVisible = true;
                      "
                      ><View
                    /></el-icon>
                  </template>
                </el-table-column>
                <el-table-column label="PS No." prop="PSNo" width="100">
                </el-table-column>
                <el-table-column
                  label="Description"
                  prop="description"
                  min-width="130"
                />
                <el-table-column
                  label="From"
                  prop="CampaignPeriodStart"
                  min-width="60"
                >
                  <template #default="prop">
                    {{ formatDate(prop.row.CampaignPeriodStart) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="To"
                  prop="CampaignPeriodEnd"
                  min-width="60"
                >
                  <template #default="prop">
                    {{ formatDate(prop.row.CampaignPeriodEnd) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="No. of Schedule"
                  prop="NoOfSchedule"
                  min-width="130"
                />
                <el-table-column
                  label="Schedule Media Amount"
                  prop="ScheduleMediaAmount"
                  min-width="150"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.ScheduleMediaAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Schedule Production Amount"
                  prop="ScheduleProductionAmount"
                  min-width="220"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.ScheduleProductionAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Total Schedule Amount"
                  prop="TotalScheduleAmount"
                  min-width="150"
                >
                  <template #default="prop">
                    {{ util.getMoneyFormat(prop.row.TotalScheduleAmount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Paid Amount"
                  prop="PaidAmount"
                  min-width="70"
                >
                </el-table-column>
                <el-table-column label="Has Invoice" min-width="70">
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <!-- <el-table :data="paymentScheduleData" v-if="!isMAndP">
          <el-table-column width="70">
            <template #default="prop">
              <el-icon
                style="position: relative; top: 3px; cursor: pointer"
                @click="
                  dialogType = 'edit';
                  dialogVisible = true;
                "
                v-if="!prop.row.hasInvoice"
                ><Edit
              /></el-icon>
              <el-icon
                style="position: relative; top: 3px; cursor: pointer"
                @click="
                  dialogType = 'view';
                  dialogVisible = true;
                "
                ><View
              /></el-icon>
              <el-button link v-if="prop.row.hasInvoice !== 'Yes'">
                <el-icon>
                  <Delete />
                </el-icon>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="PS No." prop="PSNo" width="100">
          </el-table-column>
          <el-table-column
            label="Description"
            prop="description"
            min-width="130"
          />
          <el-table-column
            label="From"
            prop="CampaignPeriodStart"
            min-width="60"
          >
            <template #default="prop">
              {{ formatDate(prop.row.CampaignPeriodStart) }}
            </template>
          </el-table-column>
          <el-table-column label="To" prop="CampaignPeriodEnd" min-width="60">
            <template #default="prop">
              {{ formatDate(prop.row.CampaignPeriodEnd) }}
            </template>
          </el-table-column>
          <el-table-column
            label="No. of Schedule"
            prop="NoOfSchedule"
            min-width="130"
          />
          <el-table-column
            label="Schedule Media Amount"
            prop="ScheduleMediaAmount"
            min-width="150"
          >
            <template #default="prop">
              {{ util.getMoneyFormat(prop.row.ScheduleMediaAmount) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Schedule Production Amount"
            prop="ScheduleProductionAmount"
            min-width="220"
          >
            <template #default="prop">
              {{ util.getMoneyFormat(prop.row.ScheduleProductionAmount) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Total Schedule Amount"
            prop="TotalScheduleAmount"
            min-width="150"
          >
            <template #default="prop">
              {{ util.getMoneyFormat(prop.row.TotalScheduleAmount) }}
            </template>
          </el-table-column>
          <el-table-column label="Paid Amount" prop="PaidAmount" min-width="70">
            <template #default="prop">
              {{ util.getMoneyFormat(prop.row.PaidAmount) }}
            </template>
          </el-table-column>
          <el-table-column label="Has Invoice" min-width="70">
          </el-table-column>
        </el-table> -->
      </div>
    </div>
    <el-dialog
      v-model="dialogVisible"
      title="New Payment Schedule"
      width="95%"
      style="margin-top: 7vh"
    >
      <div v-if="dialogVisible">
        <NewPaymentSchedule
          :status="dialogVisible"
          :save="savePaymentSchedule"
          :type="dialogType"
          :saveData="savePaymentScheduleData"
          :prepareToSave="notSaveData"
          :isMAndP="isMAndP"
          :activeName="activeName"
          :payment_id="payment_id"
        ></NewPaymentSchedule>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            @click="savePaymentSchedule = true"
            v-if="dialogType != 'view'"
          >
            OK
          </el-button>
          <!-- <el-button
            type="primary"
            @click="dialogType = 'edit'"
            v-if="dialogType == 'view'"
            >Edit</el-button
          > -->
          <el-button v-if="dialogType !== 'view'" @click="dialogVisible = false"
            >Close</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseRadio from '@/components/newUI/Inputs/BaseRadio';
import moneyInput from '@/components/newUI/Inputs/MoneyInput';
import NewPaymentSchedule from './NewPaymentSchedule';
import { nextTick, ref, onMounted, reactive, watch } from 'vue';
import { usePaymentScheduleStore } from '@/store/paymentSchedule';
import { useContractStore } from '@/store/contract';
import { useAuthorityStore } from '@/store/authority';
import { storeToRefs } from 'pinia';
import { ElMessage, ElMessageBox, ElTabPane } from 'element-plus';
import { Edit, Search, Delete, Plus } from '@element-plus/icons-vue';
import { v4 as uuidv4 } from 'uuid';
import { formatter_money } from '@/assets/js/formatter';

const util = require('@/utilFunction');
const useContract = useContractStore();
const usePayment = usePaymentScheduleStore();
usePayment.$reset();
const { PaymentScheduleSummary } = storeToRefs(usePayment);

var newPaymentScheduleDialogShow = ref(false);
var dialogVisible = ref(false);
var savePaymentSchedule = ref(false);
var paymentScheduleData = ref([]);
var paymentScheduleMedia = ref([]);
var paymentScheduleProduction = ref([]);
var notSaveData = ref({});
var dialogType = ref('new');
var isNew = ref(false);
var paymentScheduleForm = reactive({
  campaignPeriod: [],
  mediaTotal: 0,
  productionTotal: 0,
  mediaOutstanding: 0,
  productionOutstanding: 0,
});
var initCampaign = {};
const payment_id = ref('');
const activeName = ref('');
const isMAndP = ref(false);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: true,
    description: '全局disabled',
  },
  isLoading: {
    type: Boolean,
    deafult: false,
    description: '刷新开关',
  },
});

const ActionNames = ref([]); // 合同Action
const ComponentType = ref('div');

var contractId = 0;

function formatDate(date) {
  return util.getDateFormat(date);
}

function savePaymentScheduleData(val, isValid) {
  // 重置SavePaymentSchedule
  savePaymentSchedule.value = false;
  if (!isValid) {
    return;
  }

  ElMessage({
    message: 'Payment Schedule updated!',
    type: 'success',
  });
  dialogVisible.value = false;
  payment_id.value = '';

  notSaveData.value = val;

  // 更新Payment Summary > OutStanding
  PaymentScheduleSummary.value.totalOutstandingMediaAmount = parseFloat(
    (
      PaymentScheduleSummary.value.totalOutstandingMediaAmount +
      (val.beforeMediaTotal || 0) -
      val.paymentSchedule.scheduleMedia
    ).toFixed(2)
  );

  PaymentScheduleSummary.value.totalOutstandingProductionAmount =
    PaymentScheduleSummary.value.totalOutstandingProductionAmount +
    (val.beforeProductionTotal || 0) -
    val.paymentSchedule.scheduleProduction;

  val.paymentSummary.totalOutstandingMedia =
    PaymentScheduleSummary.value.totalOutstandingMediaAmount;
  val.paymentSummary.totalOutstandingProduction =
    PaymentScheduleSummary.value.totalOutstandingProductionAmount;

  var tempObj = val.paymentSchedule;
  // var tempDetailObj = val.paymentScheduleDetail?.[0] || {};
  var temp = usePayment.getPaymentSchedule(tempObj.payment_id) || {};
  var tempDetails = temp?.PaymentDetail || [];
  console.log(temp);
  temp.UniqueId = tempObj.payment_id;
  temp.CampaignPeriodStart = tempObj.campaignStart;
  temp.CampaignPeriodEnd = tempObj.campaignEnd;
  temp.NoOfSchedule = tempObj.numOfSchedule;
  temp.ScheduleMediaAmount = tempObj.scheduleMedia;
  temp.ScheduleProductionAmount = tempObj.scheduleProduction;
  temp.TotalScheduleAmount = tempObj.totalScheduleAmount;
  temp.PaidAmount = tempObj.paidAmount;
  temp.Description = tempObj.description;
  temp.ContractAction = tempObj.contractAction;
  temp.ContractDraftNo = tempObj.contractDraftNo;
  temp.PaymentTerm = tempObj.paymentTerm;
  temp.InvoiceTerm = tempObj.invoiceTerm;
  temp.BusinessNature = tempObj.businessNature;
  temp.Keyword = tempObj.keyword;
  temp.PSType = tempObj.psType;
  temp.SpecialPaymentTerm = tempObj.specialPaymentTerm;
  temp.SpecialSetting = tempObj.specialSetting;
  temp.PaymentTermSnap = tempObj.paymentTermSnap;
  temp.FixDate = tempObj.fixDate;

  var details = tempDetails.filter((t) => t.InvoiceStatus === 'invoiced');

  val.paymentScheduleDetail.forEach((element) => {
    var tempDetail =
      tempDetails.find(
        (t) => t.PaymentDetail_Id === element.paymentDetail_Id
      ) || {};
    console.log(element);
    tempDetail.Id = element.id;
    tempDetail.PaymentDetail_Id = element.paymentDetail_Id;
    tempDetail.InvoiceIssueDate = element.invoiceDue;
    tempDetail.InvoiceStatus = element.invoiceStatus;
    tempDetail.MediaInstallmentAmount = element.mediaAmount;
    tempDetail.NoOfDays = element.days;
    tempDetail.PaymentDueDate = element.paymentDue;
    tempDetail.PaymentFrom = element.from;
    tempDetail.PaymentTo = element.to;
    tempDetail.ProductionInstallmentAmount = element.productionAmount;
    tempDetail.TotalAmount = element.totalAmount;
    tempDetail.PeriodNo = element.no;
    tempDetail.PeriodNoName = element.schedule;
    tempDetail.PaymentStatus = element.paymentStatus;

    details.push(tempDetail);
  });

  temp.PaymentDetail = details;
  if (val?.dialogNewType) {
    dialogType.value = val.dialogNewType;
  }

  if (dialogType.value === 'new') {
    paymentScheduleData.value.push(temp);
    paymentScheduleData.value.contract_entity_id =
      usePayment.getCompanyEntityId();
    usePayment.setPaymentScheduleData(paymentScheduleData.value);
  }
}
isNew.value = false;

function disabledDate(date) {
  var start = new Date(initCampaign[0]);
  start = start.setDate(start.getDate() - 1);
  var end = new Date(initCampaign[1]);
  return date < start || date > end;
}

// onMounted(() => {
//   init();
// });

const init = () => {
  contractId = useContract.Id;
  if ((contractId || 0) === 0) {
    return;
  }

  const paymentSchedule = usePaymentScheduleStore();
  paymentSchedule.$reset(); //用于存储参数后未保存, 执行的保存操作
  util.loading();
  util
    .requestFromAWS(util.dev_endpoint, 'getPaymentScheduleOptionList')
    .then((val) => {
      console.log(val?.data?.data?.[0]);
      if (val?.data?.data?.[0]) {
        paymentSchedule.setInvoiceTerm(
          JSON.parse(val.data.data[0].InvoiceTerm)
        );
        paymentSchedule.setPaymentTerm(
          JSON.parse(val.data.data[0].PaymentTerm)
        );
        paymentSchedule.setPaymentType(
          JSON.parse(val.data.data[0].PaymentType)
        );
        paymentSchedule.setPaymentTermSettings(
          JSON.parse(val.data.data[0].PaymentSettings)
        );
        paymentSchedule.setInvoiceTermSettings(
          JSON.parse(val.data.data[0].InvoiceSettings)
        );
      }
    });

  util
    .requestFromAWSWithData(util.dev_endpoint, 'getPaymentScheduleSummary', {
      contractId: contractId,
    })
    .then((val) => {
      if (!val.data?.data?.[0]) {
        util.closeLoading();
        return;
      }

      var actionDatas = JSON.parse(val.data?.data?.[0]?.ActionName || '[]');
      if (actionDatas.length > 0) {
        ActionNames.value = JSON.parse(val.data?.data?.[0].ActionName).map(
          (t) => t.Action
        );
      }

      if (
        ActionNames.value.length == 1 &&
        activeName.value !== ActionNames.value[0]
      ) {
        // 重置
        activeName.value = '';
      }

      if (
        activeName.value === '' ||
        ActionNames.value.indexOf(activeName.value) < 0
      ) {
        activeName.value = ActionNames.value[0];
      }
      if (ActionNames.value.length === 2) {
        ComponentType.value = ElTabPane;
      } else {
        ComponentType.value = 'div';
      }

      // Payment Data
      paymentScheduleData.value = JSON.parse(
        val.data.data?.[0]?.PaymentSchedule || '[]'
      );

      if (
        val.data.data[0] &&
        (val.data.data[0].MediaTotal || val.data.data[0].MediaTotal == 0)
      ) {
        isNew.value = true;
        paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignStart);
        paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignEnd);
        initCampaign = paymentScheduleForm.campaignPeriod;
        paymentScheduleForm.mediaTotal = val.data.data[0].MediaTotal;
        paymentScheduleForm.productionTotal = val.data.data[0].ProductionTotal;
        paymentScheduleForm.contractType = val.data.data[0].ContractType;
        if (paymentScheduleForm.contractType == 'media&production') {
          isMAndP.value = true;
        }
        paymentScheduleForm.contractId = contractId;
        paymentScheduleForm.mediaOutstanding = val.data.data[0].MediaTotal;
        paymentScheduleForm.productionOutstanding =
          val.data.data[0].ProductionTotal;
        paymentSchedule.setContractMedia(val.data.data[0].Media);
        paymentSchedule.setBusinessNature(val.data.data[0].BusinessNature);
        paymentSchedule.setPaymentScheduleData({});
        paymentSchedule.setAdditionalProduction(
          val.data.data[0].AdditionalProduction
        );
      } else {
        isNew.value = false;

        paymentScheduleForm.campaignPeriod.push(
          val.data.data[0].CampaignPeriodStart
        );
        paymentScheduleForm.campaignPeriod.push(
          val.data.data[0].CampaignPeriodEnd
        );
        paymentScheduleForm.mediaTotal = val.data.data[0].TotalMediaAmount;
        paymentScheduleForm.productionTotal =
          val.data.data[0].TotalOutstandingProductionAmount;
        paymentScheduleForm.mediaOutstanding = paymentScheduleForm.mediaTotal;
        paymentScheduleForm.productionOutstanding =
          paymentScheduleForm.productionTotal;
        paymentScheduleForm.contractId = contractId;
        paymentScheduleForm.contractType = val.data.data[0].ContractType;
        if (paymentScheduleForm.contractType == 'media&production') {
          isMAndP.value = true;
          var mediaTemp = [];
          var productionTemp = [];
          var productionTotal = 0;
          paymentScheduleData.value.map((val) => {
            if (val.ContractAction == 'media') {
              mediaTemp.push(val);
            }
            if (val.ContractAction == 'production') {
              productionTemp.push(val);
              productionTotal += val.ScheduleProductionAmount;
            }
          });
          console.log(productionTotal);
          paymentScheduleForm.productionTotal = productionTotal;
          paymentScheduleForm.productionOutstanding = productionTotal;
          paymentScheduleMedia.value = mediaTemp;
          paymentScheduleProduction.value = productionTemp;
        }
        paymentSchedule.setContractMedia(val.data.data[0].Media);
        paymentSchedule.setBusinessNature(val.data.data[0].BusinessNature);
        paymentSchedule.setAdditionalProduction(
          val.data.data[0].AdditionalProduction
        );
        paymentSchedule.setPaymentScheduleData(paymentScheduleData.value);
      }

      paymentSchedule.setPaymentKeywords(
        JSON.parse(val.data.data[0].PaymentKeywords)
      );

      paymentSchedule.setPaymentScheduleSummary({
        id: val.data.data[0].PaySummary_Id || '',
        contractId: contractId,
        campaignPeriodStart:
          val.data.data[0].CampaignPeriodStart ||
          val.data.data[0].CampaignStart,
        campaignPeriodEnd:
          val.data.data[0].CampaignPeriodEnd || val.data.data[0].CampaignEnd,
        totalMediaAmount:
          val.data.data[0].TotalMediaAmount || val.data.data[0].MediaTotal,
        totalProductionAmount:
          val.data.data[0].TotalProductionAmount ||
          val.data.data[0].ProductionTotal ||
          0,
        totalOutstandingMediaAmount:
          val.data.data[0].TotalOutstandingMediaAmount ||
          val.data.data[0].MediaTotal ||
          0,
        totalOutstandingProductionAmount:
          val.data.data[0].TotalOutstandingProductionAmount ||
          val.data.data[0].ProductionTotal ||
          0,
      });

      if (val.data.data[0].CompanyList) {
        paymentSchedule.setCompanyEntityId(
          JSON.parse(val.data.data[0].CompanyList).find((t) => t.alias === 'BM')
            ?.ID
        );
      }

      util.closeLoading();
    })
    .catch((err) => {
      ElMessage({
        message:
          'Fail to get payment term settings, please contact system administrator.',
        type: 'error',
      });
      util.closeLoading();
    });
};

const addPaymentDisabled = (val) => {
  if (val === 'media') {
    return !(
      (PaymentScheduleSummary.value.totalOutstandingMediaAmount || 0) > 0
    );
  } else if (val === 'production') {
    return !(
      (PaymentScheduleSummary.value.totalOutstandingProductionAmount || 0) > 0
    );
  }

  return true;
};

// 删除Payment
const deleteClick = async (id) => {
  const action = await ElMessageBox.confirm(
    'Are you sure you want to delete the payment schedule?',
    'Delete Payment Schedule',
    {
      distinguishCancelAndClose: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
      closeOnPressEscape: false,
      closeOnClickModal: false,
    }
  )
    .then(() => {
      return 'delete';
    })
    .catch((action) => {
      return action;
    });

  if (action === 'delete') {
    var param = usePayment.getsetDataPrepareForSave();
    if (!param?.deletePaymentIds) {
      param.deletePaymentIds = [];
    }

    var data = paymentScheduleData.value.find((t) => t.UniqueId === id);
    if (data?.Id) {
      param.deletePaymentIds.push(id);
    }

    const index = paymentScheduleData.value.indexOf(data);
    if (index >= 0) {
      paymentScheduleData.value.splice(index, 1);
    }

    if (
      data.ContractAction !== 'production' ||
      data.ContractAction === 'media+production'
    ) {
      PaymentScheduleSummary.value.totalOutstandingMediaAmount +=
        data.ScheduleMediaAmount;
    }
    if (
      data.ContractAction !== 'media' ||
      data.ContractAction === 'media+production'
    ) {
      PaymentScheduleSummary.value.totalOutstandingProductionAmount +=
        data.ScheduleProductionAmount;
    }

    if (!param?.paymentSummary) {
      const dateJs = require('@/assets/js/date').default;
      param.paymentSummary = {};

      param.paymentSummary.campaignStart =
        PaymentScheduleSummary.value.campaignPeriodStart;
      param.paymentSummary.campaignEnd =
        PaymentScheduleSummary.value.campaignPeriodEnd;
      param.paymentSummary.days =
        dateJs.DateDiff(
          param.paymentSummary.campaignStart,
          param.paymentSummary.campaignEnd
        ) + 1;

      param.paymentSummary.id = PaymentScheduleSummary.value.id;
      param.paymentSummary.contractId = useContract.Id;
    }

    param.paymentSummary.totalMediaAmount =
      PaymentScheduleSummary.value.totalMediaAmount;
    param.paymentSummary.totalProductionAmount =
      PaymentScheduleSummary.value.totalProductionAmount;
    param.paymentSummary.totalOutstandingMedia =
      PaymentScheduleSummary.value.totalOutstandingMediaAmount;
    param.paymentSummary.totalOutstandingProduction =
      PaymentScheduleSummary.value.totalOutstandingProductionAmount;
    param.paymentSummary.Currency = 'HKD';

    if (param.paymentSchedule) {
      const data = param.paymentSchedule.find((t) => t.payment_id === id);
      const row_index = param.paymentSchedule.indexOf(data);
      if (row_index >= 0) {
        param.paymentSchedule.splice(row_index, 1);
      }
    }

    if (param?.paymentScheduleDetail) {
      // const data = param.paymentScheduleDetail.find((t) => t.payment_id === id);
      // const row_index = param.paymentScheduleDetail.indexOf(data);
      // if (row_index >= 0) {
      //   param.paymentScheduleDetail.splice(row_index, 1);
      // }

      param.paymentScheduleDetail = param.paymentScheduleDetail.filter(
        (t) => t.payment_id != id
      );
    }

    const useAuthority = useAuthorityStore();
    param.userCode = useAuthority.UserInfo.user_name;
    param.userName = useAuthority.UserInfo.name;
  }
};

const SetHeaderBackground = (item) => {
  return item.column.property === 'HasInvoice' ? 'text-primary' : '';
};

watch(
  () => props.isLoading,
  (val) => {
    if (val) {
      init();
    }
  },
  { immediate: true }
);
</script>
<style scoped>
.icon-button {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.icon-button.add {
  background-color: #409eff;
  color: #fff;
}
</style>
